import CustomText from "@components/CustomText";
import { colors } from "@constants/theme";

import React from "react";
import {
  TouchableOpacity,
  StyleSheet,
  View,
  ActivityIndicator,
} from "react-native";

const BottomButton = ({
  onPress = () => {},
  title = "",
  loading = false,
  disable = false,
  showBottomContainer = true,
}) => {
  return (
    <View
      style={showBottomContainer ? styles.absoluteContainer : { width: "100%" }}
    >
      <TouchableOpacity
        testID="docl-crate-scan"
        disabled={loading || disable}
        activeOpacity={0.8}
        onPress={onPress}
        style={[
          styles.scanButton,
          disable && { backgroundColor: colors.black02 },
        ]}
      >
        {loading ? (
          <ActivityIndicator size="small" color={colors.white} />
        ) : (
          <CustomText variant="title_16" style={styles.scanButtonText}>
            {title}
          </CustomText>
        )}
      </TouchableOpacity>
    </View>
  );
};

export default BottomButton;

const styles = StyleSheet.create({
  absoluteContainer: {
    backgroundColor: "white",
    position: "absolute",
    paddingBottom: 10,
    bottom: 0,
    width: "100%",
    padding: 16,
    elevation: 10,
  },
  scanButton: {
    backgroundColor: colors.plain_green,
    paddingVertical: 10,
    alignItems: "center",
    borderRadius: 8,
  },
  scanButtonText: {
    color: colors.white,
  },
});
